import { FormActions } from "../../components/common/FormActions";
import {
  ActionTypeTag,
  BooleanTags,
  SeverityTag,
} from "../../components/common/registerUtils";
import { createViewAction, formatDateTime } from "../../utils/helpers";
import { URL_FRAUD_RULES } from "../../utils/urls";

const url = URL_FRAUD_RULES;

export const useFraudRulesHistory = () => {
  const tableColumns = () => [
    { id: "code", header: "Code", filter: {} },
    { id: "name", header: "Name", filter: {} },
    { id: "category", header: "Category", filter: {} },
    { id: "severity", header: "Severity", filter: {} },
    { id: "score_weight", header: "Score Weight", filter: {} },
    { id: "action_type", header: "Action Type", filter: {} },
    { id: "is_active", header: "Is Active", filter: {} },
    {
      id: "applies_to_user_types",
      header: "User Types",
      filter: {},
    },
    { id: "trigger_count", header: "Trigger Count", filter: {} },
    { id: "trigger_rate", header: "Trigger Rate", filter: {} },
    { id: "last_triggered", header: "Last Triggered", filter: {} },
    { id: "created_at", header: "Created At", filter: {} },
    { id: "updated_at", header: "Updated At", filter: {} },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => ({
      ...item,
      created_at: formatDateTime(item?.created_at),
      updated_at: formatDateTime(item?.updated_at),
      trigger_count: String(item?.trigger_count ?? 0),
      trigger_rate: String(item?.trigger_rate ?? 0),
      severity: <SeverityTag severity={item?.severity} />,
      is_active: <BooleanTags status={item?.is_active} />,
      action_type: <ActionTypeTag action_type={item?.action_type} />,
      last_triggered: item?.last_triggered
        ? formatDateTime(item?.last_triggered)
        : "Never",
      applies_to_user_types: Array.isArray(item?.applies_to_user_types)
        ? item?.applies_to_user_types
            .map(
              (type: string) =>
                type.charAt(0).toUpperCase() + type.slice(1).toLowerCase(),
            )
            .join(", ")
        : item?.applies_to_user_types,
      actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
    })),
  ];

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Fraud Rule Details",
          fields: {
            code: item?.code,
            name: item?.name,
            description: item?.description,
            category: item?.category,
            severity: item?.severity,
            score_weight: item?.score_weight,
            action_type: item?.action_type,
            is_active: item?.is_active ? "Active" : "Inactive",
            applies_to_user_types: Array.isArray(item?.applies_to_user_types)
              ? item?.applies_to_user_types
                  .map(
                    (type: string) =>
                      type.charAt(0).toUpperCase() +
                      type.slice(1).toLowerCase(),
                  )
                  .join(", ")
              : item?.applies_to_user_types,
          },
        },
        {
          title: "Parameters",
          fields: item?.parameters || { message: "No parameters configured" },
        },
        {
          title: "Statistics",
          fields: {
            trigger_count: String(item?.trigger_count ?? 0),
            trigger_rate: String(item?.trigger_rate ?? 0),
            last_triggered: item?.last_triggered
              ? formatDateTime(item?.last_triggered)
              : "Never",
          },
        },
        {
          title: "Audit Information",
          fields: {
            created_by: item?.created_by_name,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};
